/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { lazy, useContext, Fragment } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { RendererContext } from '../../context';
import MediaServicesNoImageIcon from '@atlaskit/icon/glyph/media-services/no-image';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
var AKButton = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.button' */
  '@atlaskit/button');
});
var LinkWithIcon = function LinkWithIcon(_ref) {
  var href = _ref.href,
    text = _ref.text;
  return jsx(AKButton, {
    iconAfter: jsx(ShortcutIcon, {
      label: ""
    }),
    appearance: "link",
    href: href,
    target: "_blank",
    spacing: "none"
  }, text);
};
export var EgressErrorMessage = function EgressErrorMessage(_ref2) {
  var url = _ref2.url;
  var _useContext = useContext(RendererContext),
    forgeEnvironment = _useContext.forgeEnvironment;
  var dataUriRegex = /^data/;
  var isDataUri = dataUriRegex.test(url);
  if (forgeEnvironment === 'DEVELOPMENT') {
    return jsx("div", {
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      css: css({
        display: 'flex',
        padding: "var(--ds-space-150, 12px)"
      }),
      "data-testid": "egress-error-message"
    }, jsx("div", {
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      css: css({
        alignSelf: 'center'
      })
    }, jsx(MediaServicesNoImageIcon, {
      label: "",
      size: "large"
    })), jsx("div", {
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      css: css({
        display: 'flex',
        paddingLeft: "var(--ds-space-150, 12px)",
        color: "var(--ds-text-accent-red, #AE2A19)",
        overflow: 'hidden'
      })
    }, jsx(ErrorIcon, {
      label: ""
    }), jsx("p", {
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      css: css({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&&': {
          paddingLeft: "var(--ds-space-050, 4px)",
          margin: "var(--ds-space-0, 0px)",
          alignSelf: 'start',
          overflow: 'hidden'
        }
      })
    }, isDataUri ? jsx(Fragment, null, "Please use the ", jsx("b", null, "data:image"), " scheme for an image source.") : jsx(Fragment, null, "Egress permissions for ", jsx(LinkWithIcon, {
      href: url,
      text: url
    }), " missing in the manifest. For more information", ' ', jsx(LinkWithIcon, {
      href: "https://developer.atlassian.com/platform/forge/manifest-reference/permissions/#images",
      text: "see reference docs"
    }), "."))));
  }
  return jsx("div", {
    title: "Unable to display due to an image link issue."
  }, jsx(MediaServicesNoImageIcon, {
    label: ""
  }));
};